import { CollectionNames } from '../utils/collectionNames';
import { EmailSignatureItemResponse } from '../schema/EmailSignatureResponse';
import { EmailSignaturePreference } from '../schema/EmailSignaturePreference';
import { getEmailSignaturePreferenceItemIdFromCache } from 'mini-mail-signature';
import { ItemNames } from '../utils/itemNames';
import {
    getSDSCollectionItemIdUsingItemClass,
    updateSDSCollectionItemWithId,
} from 'mini-sds-gateway';

export const updateEmailSignaturePreference = async (
    data: EmailSignaturePreference
): Promise<EmailSignatureItemResponse> => {
    let itemId = getEmailSignaturePreferenceItemIdFromCache();

    if (!itemId) {
        itemId = await getSDSCollectionItemIdUsingItemClass(
            CollectionNames.ExtensionUserCustomProperties,
            ItemNames.EmailSignatureSettingsItem
        );
    }
    return updateSDSCollectionItemWithId(CollectionNames.ExtensionUserCustomProperties, itemId, {
        data,
    });
};
